<template lang="html">
  <div class="col-md-12 text-center">
    <div class="row mx-0">
      <TermsConditions button-that-agrees-text="Logging in, Registering or Creating a page" />
    </div>
    <Loader/>
    <p class="loggedin-text mt-4">Signed in as {{ $store.state.userLogon }}<br />not you? <a 
      class="stLogout primary-link" 
      @click="LogoutUser">Logout</a></p>
    <div class="row">
      <div class="col-md-6 m-auto">
        <button 
          id="btn-create" 
          :disabled="creatingPage || teamDetailsInValid()" 
          class="btn btn-block btn-driver" 
          @click="submitFormComplete">Create</button>
      </div>
      
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loader from '../inc/Loader.vue'
import TermsConditions from './TermsConditions.vue'

export default {
  components: { 
    Loader,
    TermsConditions
  },
  data() {
    return {
      creatingPage: false
    }
  },

  mounted() {
    var vm = this;
    this.$root.$on('pageCreationFailed', function() {
      vm.creatingPage = false;
    });
  },

  methods:{
    LogoutUser(){
      var vm = this;
      axios
        .get("/account/logoff?isPopUp=true", {
					headers: {
						"Content-Type": "application/json"
					},
				})
        .then(function (res) {
          if (res.data.success) {
            vm._onSuccessfulLogout();
          }
          else {
            this.$gfLogger.logInfo('logoff failed');
          }
        });
    },

    teamDetailsInValid: function() {
      if (this.$store.state.pageType !== "createTeam")
        return false;
      return (this.$store.state.details_team.teamTarget === '') || (this.$store.state.details_team.teamName === '')
    },
    
    submitFormComplete(){
      this.$emit('submitFormComplete');
      this.$root.$emit('creatingPage');
      this.creatingPage = true;
    },

    _onSuccessfulLogout: function() {
      this.$store.commit('preUserLogin', '');
    }
  }
}
</script>

<style>
.loggedin-text, .loggedin-text a{
  font-size: 16px;
}

#btn-create {
  font-size: 18px;
  background-color: #F57C33;
  color:#fff;
  border-radius: 20px;
}

</style>